export enum PlatformHostIntegration {
  aeroMHost = '/integrations'
}
